import { createFileRoute, useParams } from '@tanstack/react-router';

import { BusinessImpactAnalysisRecordPage } from '@/features/bcp/components/BusinessImpactAnalysisPage';

export const Route = createFileRoute('/_authenticated/bcp/bia/$biaId')({
  beforeLoad: () => ({
    getTitle: () => 'BIA Record',
  }),
  component: BusinessImpactAnalysisRecordRoute,
});

function BusinessImpactAnalysisRecordRoute() {
  const { biaId } = useParams({ from: '/_authenticated/bcp/bia/$biaId' });

  return <BusinessImpactAnalysisRecordPage recordId={biaId} />;
}
